import React from 'react';
import { EnumMediaType } from '../../index';
import { IBuilderMediaData } from '../../../../../../Data';
import { useMessageManagerProvider } from '../../../../../../../../../../context/messageManager';
import Checkbox from '../../../../../../../../../../../components/Common/UI/Checkbox';
import { Empty } from '../../../../../index';

interface IMediaItem {
  data: IBuilderMediaData;
  type: EnumMediaType;
}

function MediaItem({ data, type }: IMediaItem) {
  const { handleSelectedImage, selectedImage } = useMessageManagerProvider();

  return (
    <a
      href="#"
      className="rounded-lg w-[150px] overflow-hidden cursor-pointer relative block no-underline"
      onClick={e => {
        e.preventDefault();
        handleSelectedImage({
          id: data.id,
          imageUrl: type === EnumMediaType.images ? data.imageUrl : '/infoTrac/images/qrCode.jpg',
        });
      }}
    >
      <Checkbox
        checked={data.id === selectedImage?.id}
        className="absolute right-[10px] top-[10px] data-[state=unchecked]:border-none
        data-[state=unchecked]:shadow-none"
      />
      <div className="bg-[#ebedee] flex items-center h-[150px] justify-center overflow-hidden">
        {EnumMediaType.images && !data.imageUrl ? (
          <Empty placeholder="IMG" />
        ) : (
          <img
            src={type === EnumMediaType.images ? data.imageUrl : '/infoTrac/images/qrCode.jpg'}
            className="h-full object-contain"
            alt="media"
          />
        )}
      </div>
      <div className="text-sm">
        <div className="opacity-70">Lorem Ipsum dolor</div>
        <div className="opacity-30">Text</div>
      </div>
    </a>
  );
}

export default MediaItem;
